import Phaser from 'phaser';
import store from '@/store';
import router from '@/router';
import EDC from '@/components/games/shared/globals';
import TypeSelector from './type-selector';
import Preview from './preview';
import List from './avatars-list';
import CursorManager from '@/components/games/shared/cursor-manager';
import Button from '@/components/games/shared/button';
import { getAvatarNameByPath } from '@/helpers/profile/avatar';

/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.init = function () {
  this.gameConfig = EDC.Games.AvatarSelect.Config;
  this.bg = null;
  this.avatarWindow = null;
  this.content = null;
  this.avatarsContent = null;
  this.avatarsUI = null;
  this.avatarsContentMaskGeom = null;
  this.filtersUI = null;
  this.list = null;
  this.preview = null;
  this.activeAvatarItem = null;
  this.activeFilterItem = null;
  this.filters = [];
  this.backButton = null;
  this.cursorManager = null;
  this.backPos = { x: 100, y: 100 };

  this.events.off(this.gameConfig.signals.S_ITEM_ACTIVATED, this.activateAvatar, this);
  this.events.off(this.gameConfig.signals.S_FILTER_ACTIVATED, this.activateFilter, this);
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);

  this.events.on(this.gameConfig.signals.S_ITEM_ACTIVATED, this.activateAvatar, this);
  this.events.on(this.gameConfig.signals.S_FILTER_ACTIVATED, this.activateFilter, this);

  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();
  //  this.backContainer = this.add.container();

  this.avatarsContent = this.add.container();
  this.avatarsContent.setData('baseX', 0);
  this.avatarsContent.setData('baseY', 0);
  this.avatarsContentMaskGeom = this.make.graphics();
  this.avatarsContentMaskGeom.fillCircle(this.avatarsContent.x, this.avatarsContent.y, 250);
  const mask = new Phaser.Display.Masks.GeometryMask(this, this.avatarsContentMaskGeom);
  this.avatarsContent.setMask(mask);

  this.avatarsUI = this.add.container();
  this.filtersUI = this.add.container();

  this.avatarWindow = this.add.sprite(0, 220, 'window').setOrigin(0);
  //  avatar-title
  const logo = this.add.sprite(0, 0, 'logo').setOrigin(0);

  const frame = this.add
    .sprite(this.avatarWindow.width / 2 + logo.displayWidth / 2, this.avatarWindow.y - 120, 'title-frame')
    .setOrigin(0.5, 0.5);

  const title = this.add.sprite(frame.x, frame.y, 'avatar-title').setOrigin(0.5, 0.5);

  // let logo = this.add.sprite(0, 0, "logo");
  // logo.setScale(1.5);

  // let titleFrame = this.add.sprite(0, 0, "title-frame");
  // titleFrame.setScale(1.5);
  // titleFrame.setPosition(titleFrame.displayWidth / 2 + logo.displayWidth / 2,
  // titleFrame.displayHeight / 2);
  this.avatarWindow.setPosition(logo.displayWidth / 2, 220);
  logo.setPosition(40, frame.displayHeight / 2 - 185);
  this.content.add([this.avatarWindow, frame, logo, title]);

  this.createTypeFilters();

  this.preview = new Preview(this,
    this.content, this.avatarWindow.x + 230, this.avatarWindow.y + 460).create();

  const listX = this.avatarWindow.x + this.avatarWindow.displayWidth / 2;
  const listY = this.avatarWindow.y + this.avatarWindow.displayHeight / 2;
  this.list = new List(this, this.content,
    this.avatarsContent, this.avatarsUI, listX, listY).create();

  this.filters[0].activate();

  const url = new URL(window.location.href);
  const activeChildProfile = store.getters['children/activeChildProfile'];
  const isActiveProfileAvatar = a => getAvatarNameByPath(a.data.img) === activeChildProfile.avatar;
  const activeAvatarId = (activeChildProfile && url.searchParams.get('edit'))
    ? this.list.avatarsList.find(isActiveProfileAvatar)?.data.id : null;
  this.list.activateItem(activeAvatarId || 1);

  this.backButton = new Button(this, this.backPos.x, this.backPos.y).create('back-normal', 'back-hover');
  this.backButton.setClickCallback(this.onBackBtnClick.bind(this));

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.onBackBtnClick = function () {
  const url = new URL(window.location.href);
  if (url.searchParams.get('edit') === 'avatar') {
    router.push({ name: 'profile' });
  } else {
    this.backToGender();
  }
};

EDC.Games.AvatarSelect.Scenes.Main.prototype.backToGender = function () {
  this.input.enabled = false;
  this.time.delayedCall(200, this.previousScene, [], this);
};

EDC.Games.AvatarSelect.Scenes.Main.prototype.previousScene = function () {
  this.scene.start('mainGender');
};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.activateFilter = function (filterItem) {
  if (this.activeFilterItem) {
    this.activeFilterItem.deactivate();
  }
  this.activeFilterItem = filterItem;
  this.list.applyFilter(filterItem.type);
};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.activateAvatar = function (avatarItem) {
  if (this.activeAvatarItem) {
    this.activeAvatarItem.deactivate();
  }
  this.activeAvatarItem = avatarItem;
  this.preview.setAvatar(avatarItem);
};
/**
 *
 */
EDC.Games.AvatarSelect.Scenes.Main.prototype.createTypeFilters = function () {
  const { types } = this.gameConfig;
  let x = 0;
  const stepX = 20;
  let separator = this.add.sprite(x, 0, 'type-separator').setOrigin(0.5, 0);
  separator.setScale(0.7);
  x += stepX;
  this.filtersUI.add(separator);
  for (let i = 0; i < types.length; i++) {
    const data = types[i];
    const selector = new TypeSelector(data.type, this, this.filtersUI, x, 0).create();
    const width = selector.getWidth();
    x += width + stepX;
    separator = this.add.sprite(x, 0, 'type-separator').setOrigin(0.5, 0);
    separator.setScale(0.7);
    x += stepX;
    this.filtersUI.add(separator);
    this.filters.push(selector);
  }
};
/**
 *
 */


EDC.Games.AvatarSelect.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.avatarsContent.setPosition(0, 0);
  this.content.setScale(1, 1);
  this.avatarsContent.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.9) / contentWidth;
  const scaleY = (height * 0.9) / contentHeight;

  // neededScale = width > height ? scaleY : scaleX;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2 - 50, (height - bounds.height) / 2);

  this.avatarsContent.setScale(neededScale);
  const ax = this.content.x + (this.avatarWindow.x + 420) * neededScale;
  const ay = this.content.y + (this.avatarWindow.y + 95) * neededScale;
  const areaWidth = this.list.getListAreaWidth() * neededScale;
  const areaHeight = this.list.getListAreaHeight() * neededScale;
  this.avatarsContent.setPosition(ax, ay);
  this.avatarsContent.setData('baseX', ax);
  this.avatarsContent.setData('baseY', ay);
  this.avatarsContentMaskGeom.clear();
  const xAdd = 20 * neededScale;
  const yStartAdd = 20 * neededScale;
  this.avatarsContentMaskGeom.fillRect(
    this.avatarsContent.x,
    this.avatarsContent.y + yStartAdd,
    areaWidth + xAdd,
    areaHeight,
  );

  this.avatarsUI.setScale(neededScale);
  this.avatarsUI.setPosition(ax, ay);

  this.filtersUI.setScale(neededScale);
  const filterBounds = this.filtersUI.getBounds();
  this.filtersUI.setPosition(
    this.content.x + ((this.avatarWindow.x + this.avatarWindow.displayWidth) / 2) * neededScale
    - filterBounds.width / 2,
    this.content.y + this.avatarWindow.y * neededScale + 22 * neededScale,
  );

  this.list.restoreScroll();

  this.backButton.setScale(1, 1);
  const backSize = this.backButton.getSize();
  const backScaleX = (width * 0.07) / backSize.width;
  const backScaleY = (height * 0.07) / backSize.height;
  neededScale = backScaleX > backScaleY ? backScaleX : backScaleY;
  this.backButton.setScale(neededScale, neededScale);
  this.backButton.setPosition(this.backPos.x * neededScale, height - this.backPos.y * neededScale);
};

export default EDC.Games.AvatarSelect.Scenes.Main;
